import { atom } from 'recoil';

export const imageUrlsState = atom({
  key: 'imageUrlsState',
  default: [] as string[],
});
